import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'
import { parseISO, format } from 'date-fns'

const MetaTags = ({ resolvedUrl, article }) => {
  const pathName = resolvedUrl?.split('?')[0]

  const title = `${article?.title || ''} - 信義居家`
  const keywords = article?.keywords?.map((keyword) => keyword.name).join(',')

  const classification = article?.articleClassification
  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '找好文',
        item: 'https://livinglife.com.tw/article',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: classification?.name,
        item: `https://livinglife.com.tw/article-classification/${classification?.urlId}`,
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: article?.title,
        item: LS_APP_DOMAIN + pathName,
      },
    ],
  }

  const articleData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article?.title,
    image: [article?.image?.url],
    datePublished: format(parseISO(article?.createdAt), 'yyyy-MM-dd'),
    dateModified: format(parseISO(article?.updatedAt), 'yyyy-MM-dd'),
    author: [
      {
        '@type': 'Organization',
        name: article.vender?.shortname || article?.byline,
        url: article?.vender?.introductionInfo?.isVisible
          ? `${LS_APP_DOMAIN}/vender/${article.vender?.urlId}`
          : undefined,
      },
    ],
  }

  return (
    <Head>
      <title>{title}</title>

      <link
        key="canonical"
        rel="canonical"
        href={`${LS_APP_DOMAIN + pathName}`}
      />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      <meta
        key="description"
        name="description"
        content={article?.summary || ''}
      />
      <meta key="keywords" name="keywords" content={keywords} />

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:description"
        property="og:description"
        content={article?.summary || ''}
      />
      <meta
        key="og:url"
        property="og:url"
        content={`${LS_APP_DOMAIN + pathName}`}
      />
      <meta
        key="og:image"
        property="og:image"
        content={article?.image?.url || ''}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleData) }}
      />
    </Head>
  )
}

export default MetaTags
